export default {
  methods: {
    handleScroll() {
      this.$store.commit('app/setScroll', {
        x: window.scrollX,
        y: window.scrollY,
      })
    },
  },
  beforeMount() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
